import { useEffect } from 'react';
import { useState } from 'react';
import Container from 'react-bootstrap/Container';

import { useLocation, useParams } from 'react-router-dom';
import { getAppImagesUrl } from '../../services/service-utils';
import { getActivity } from '../../services/my-activities.service';

function FolderActivityPage() {
  const { folderId } = useParams<{ folderId: string }>();
  const { activityId } = useParams<{ activityId: string }>();

  const [folderActivity, setFolderActivity] = useState<any>(null);

  const fetchActivity = async (id: string) => {
    if (id === '') {
      setFolderActivity(null);
    }
    const tmpActivity = await getActivity(id);
    if (!tmpActivity) {
      setFolderActivity(null);
    }

    setFolderActivity(tmpActivity);
  };

  useEffect(() => {
    fetchActivity(folderId ?? '');
  }, []);
  return (
    <>
      <div className='row trip-info'>
        <div className='col'>
          <Container className='outer-container'>
            <span>
              <h2>{folderActivity === null ? '' : folderActivity?.title}</h2>
            </span>
            <div className='row'>
              <div className='col'>
                <img
                  className='trip-image'
                  src={
                    folderActivity === null
                      ? ''
                      : getAppImagesUrl() + folderActivity?.imageUrl
                  }
                  alt='default.jpg'
                />
              </div>
              <div className='col'>
                <div className='row'>
                  <div className='col'>
                    <span className='label'>
                      {' '}
                      Description:
                      <span>
                        {folderActivity === null
                          ? ''
                          : folderActivity?.description}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <div className='col'>
          <div className='row'>
            <div className='col'>
              <Container className='outer-container'>
                This is the notes container
              </Container>
            </div>
            <div className='col'>
              <Container className='outer-container'>
                this is the map container
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FolderActivityPage;
